//***Modal Dialog for Application Updates - non angular **/
var modalUpdates;
var isDownloanding = false;
var isCheckForUpdate = false;

(function() {

  if ('applicationCache' in window && !('serviceWorker' in navigator)) {
    modalUpdates = $('.modal-updating').modal({
      backdrop: 'static',
      keyboard: true,
      show: false
    });
    modalUpdates.show = function() {
      modalUpdates.removeClass('update-success');
      modalUpdates.find('.progress').show();
      modalUpdates.find('.message-success').hide();
      modalUpdates.find('.message-danger').hide();
      modalUpdates.find('.message-no-update').hide();
      modalUpdates.find('.btn-update-retry').hide();
      modalUpdates.find('.btn-update-close').hide();
      modalUpdates.find('.btn-update-ok').hide();
      $('.modal-dialog').modal('hide');
      modalUpdates.modal('show');
    }
    modalUpdates.hide = function() {
      modalUpdates.modal('hide');
    }
    modalUpdates.success = function() {
      modalUpdates.show();
      modalUpdates.find('.progress').hide();
      modalUpdates.find('.message-success').show();
      modalUpdates.find('.message-danger').hide();
      modalUpdates.find('.message-no-update').hide();
      modalUpdates.find('.btn-update-retry').hide();
      modalUpdates.find('.btn-update-close').hide();
      modalUpdates.find('.btn-update-ok').show();
      modalUpdates.addClass('update-success');
      setTimeout(function() {
        modalUpdates.modal('hide');
      }, 2000);
    }
    modalUpdates.noUpdate = function() {
      modalUpdates.show();
      modalUpdates.find('.progress').hide();
      modalUpdates.find('.message-success').hide();
      modalUpdates.find('.message-danger').hide();
      modalUpdates.find('.message-no-update').show();
      modalUpdates.find('.btn-update-retry').hide();
      modalUpdates.find('.btn-update-close').hide();
      modalUpdates.find('.btn-update-ok').show();
      isCheckForUpdate = false;
    }

    modalUpdates.failure = function(errorMessage) {
      modalUpdates.show();
      modalUpdates.find('.progress').hide();
      modalUpdates.find('.message-success').hide();
      modalUpdates.find('.message-danger').show();
      modalUpdates.find('.message-no-update').hide();
      modalUpdates.find('.btn-update-retry').show();
      modalUpdates.find('.btn-update-close').show();
      modalUpdates.find('.btn-update-ok').hide();
      //setTimeout(function(){location.reload();}, 2000);
      if (errorMessage && errorMessage != '') {
        modalUpdates.find('.update-error').text(errorMessage);
      } else {
        modalUpdates.find('.update-error').text('');
      }
    }
    modalUpdates.on('hidden.bs.modal', function(e) {
      var b = modalUpdates.hasClass('update-success');
      if (b) location.reload(true);
    })
  }

}).call(this);


//** ApplicationCache Events & Actions **//
(function() {
  ////////////////////////////////////////////////////index scripts (cache)////////////////////////////////////////////////////
  if ('applicationCache' in window && !('serviceWorker' in navigator)) {
    // Convenience array of status values

    var cacheHandler = function() {}

    cacheHandler.cacheStatusValues = [];
    cacheHandler.cacheStatusValues[0] = 'uncached';
    cacheHandler.cacheStatusValues[1] = 'idle';
    cacheHandler.cacheStatusValues[2] = 'checking';
    cacheHandler.cacheStatusValues[3] = 'downloading';
    cacheHandler.cacheStatusValues[4] = 'updateready';
    cacheHandler.cacheStatusValues[5] = 'obsolete';

    cacheHandler.onDownloading = function(e) {
      isDownloanding = true;
      modalUpdates.show();
      cacheHandler.logEvent(e);
    }
    cacheHandler.onCached = function(e) {
      modalUpdates.hide();
      cacheHandler.logEvent(e);
    }
    cacheHandler.onChecking = function(e) {
      //ShowWaitDialog();
      cacheHandler.logEvent(e);
    }
    cacheHandler.onProgress = function(e) {}
    cacheHandler.onObsolete = function(e) {}
    cacheHandler.onError = function(e) {
      //debugger;
      var message = "Could not download application updates due to an unexpected error.\n" +
        "make sure that cache.manifest is being served with MIME type: text/cache-manifest";
      //actual error message if any
      if (e.message) message = e.message;
      console.error(message);
      //hide update dialog if visible
      if (isDownloanding) {
        modalUpdates.failure(message);
      } else {
        modalUpdates.hide();
      }
    }
    cacheHandler.onNoUpdate = function(e) {
      if (isCheckForUpdate) {
        modalUpdates.noUpdate();
      } else {
        modalUpdates.hide();
      }
      isDownloanding = false;
      cacheHandler.logEvent(e);
    }
    cacheHandler.onUpdateReady = function(e) {
        try {
          cache.swapCache();
        } catch (e) {}
        cacheHandler.logEvent(e);
        isDownloanding = false;
        modalUpdates.success();
        //location.reload(true);
      }
      // Log every event to the console
    cacheHandler.logEvent = function(e) {
      // var status, type, message; //online,
      // //online = (navigator.online) ? 'yes' : 'no';
      // status = cacheHandler.cacheStatusValues[cache.status];
      // type = e.type;
      // message = '';//'online: ' + online;
      // message += 'CACHE: event: ' + type;
      // message += ', status: ' + status;
      // if (type == 'error' && navigator.online) {
      // message += ' (prolly a syntax error in manifest)';
      // }
      // console.log(message);
    }

    var cache = window.applicationCache;
    cache.addEventListener('cached', cacheHandler.onCached, false);
    cache.addEventListener('checking', cacheHandler.onChecking, false);
    cache.addEventListener('downloading', cacheHandler.onDownloading, false);
    cache.addEventListener('error', cacheHandler.onError, false);
    //cache.addEventListener('error', cacheHandler.logEvent, false);
    cache.addEventListener('noupdate', cacheHandler.onNoUpdate, false);
    cache.addEventListener('obsolete', cacheHandler.onObsolete, false);
    cache.addEventListener('progress', cacheHandler.onProgress, false);
    cache.addEventListener('updateready', cacheHandler.onUpdateReady, false);
  }

  $('#update-error-btn').click(function() {
    var alert = $('.hidden-update-error');
    if (alert.hasClass('hidden')) {
      alert.removeClass('hidden');
      $('#update-error-btn').text("show less");
    } else {
      alert.addClass('hidden');
      $('#update-error-btn').text("show more");
    }
  });

  $('body').on('click', '#update-check-btn', function() {
    isCheckForUpdate = true;
    var url = location.origin;
    $.ajax({
      type: "GET",
      url: url,
      cache: false,
      success: function() {
          //get cache
          var cache = window.applicationCache;
          // Update the user's cache
          if (cache != null && cache != undefined  && (cache.status == 1 || cache.status > 3)) {
            cache.update();
          }
        }
        /*,
                    error: function(){
                        console.log('error');
                    }*/
    });
  });

}).call(this);

$(document).on( "keydown",'.modal textarea', function(e) {
    
    var zIndex = $(this).parents('.modal').css('z-index');
    if(zIndex){
        $(this).parents('.modal').css('z-index',zIndex+1);
        $(this).parents('.modal').css('z-index',zIndex)
    }
});